const initState = () => ({
  jobTypeCodeFormats: {},
})

export const state = initState

export const getters = {
  getJobTypeCodeFormat: (state) => (entityTypeId) => {
    return state.jobTypeCodeFormats[entityTypeId] || ""
  }
}

export const mutations = {
  setJobTypeCodeFormats(state, jobTypeCodeFormats) {
    state.jobTypeCodeFormats = jobTypeCodeFormats
  },
  reset(state) {
    Object.assign(state, initState())
  },
}

export const actions = {
  async fetchJobTypeCodeFormats({commit}) {
    let jobTypeCodeFormats = {}
    try {
      jobTypeCodeFormats = await this.$axios.$get('/webpos/job-types/formats')
      commit('setJobTypeCodeFormats', jobTypeCodeFormats)

      return jobTypeCodeFormats
    }
    catch (error) {
      console.error('Error while fetching job type code formats:', error);
    }
  }
}
